export function goToHref(href: string) {
  window.location.href = href;
}
